import { defineStore } from 'pinia';

interface LoaderState {
  pendingRequests: number;
  isLoading: boolean;
  loadingText: string;
  progress: number;
}

export const useLoaderStore = defineStore('loader', {
  state: (): LoaderState => ({
    pendingRequests: 0,
    isLoading: false,
    loadingText: 'Loading...',
    progress: 0,
  }),

  getters: {
    showLoader: (state) => state.isLoading || state.pendingRequests > 0,
  },

  actions: {
    startLoading(text: string = 'Loading...') {
      this.pendingRequests++;
      this.isLoading = true;
      this.loadingText = text;
      this.progress = 0;
      this.simulateProgress();
    },

    stopLoading() {
      this.pendingRequests = Math.max(0, this.pendingRequests - 1);
      if (this.pendingRequests === 0) {
        this.progress = 100;
        setTimeout(() => {
          this.isLoading = false;
          this.progress = 0;
        }, 300);
      }
    },

    forceStop() {
      this.pendingRequests = 0;
      this.isLoading = false;
      this.progress = 0;
    },

    setProgress(value: number) {
      this.progress = Math.min(100, Math.max(0, value));
    },

    setLoadingText(text: string) {
      this.loadingText = text;
    },

    simulateProgress() {
      const interval = setInterval(() => {
        if (this.progress < 90 && this.isLoading) {
          this.progress += Math.random() * 10;
        } else {
          clearInterval(interval);
        }
      }, 200);
    },
  },
});

// Export a singleton instance for use outside Vue components
let loaderStoreInstance: ReturnType<typeof useLoaderStore> | null = null;

export function getLoaderStore() {
  if (!loaderStoreInstance) {
    // This will be initialized when the store is first accessed
    const { createPinia, setActivePinia } = require('pinia');
    const pinia = createPinia();
    setActivePinia(pinia);
    loaderStoreInstance = useLoaderStore(pinia);
  }
  return loaderStoreInstance;
}

export function initLoaderStore(pinia: any) {
  loaderStoreInstance = useLoaderStore(pinia);
  return loaderStoreInstance;
}

